import { motion } from "framer-motion";
import { Trophy, RotateCcw } from "lucide-react";

const CONFETTI = Array.from({ length: 28 }).map((_, i) => ({
  id: i,
  x: Math.random() * 100,
  delay: Math.random() * 0.6,
  color: ["#38BDF8", "#F59E0B", "#EC4899", "#A855F7", "#10B981"][i % 5],
  rot: Math.random() * 360,
}));

export default function VictoryModal({ open, affection, ambushes, duration, onReplay }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 p-4 backdrop-blur-md" data-testid="victory-modal">
      {/* confetti */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        {CONFETTI.map((c) => (
          <motion.div
            key={c.id}
            initial={{ y: -40, opacity: 0, rotate: 0 }}
            animate={{ y: "110vh", opacity: [0, 1, 1, 0], rotate: c.rot + 360 }}
            transition={{ duration: 2.6, delay: c.delay, repeat: Infinity, repeatDelay: 0.4 }}
            className="absolute h-3 w-3 rounded-sm"
            style={{ left: `${c.x}%`, backgroundColor: c.color }}
          />
        ))}
      </div>

      <motion.div
        initial={{ scale: 0.8, opacity: 0, y: 30 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        className="glass relative w-full max-w-md rounded-3xl p-8 text-center"
      >
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-amber-500/20 ring-2 ring-amber-400/50">
          <Trophy className="h-8 w-8 text-amber-400" />
        </div>
        <h2 className="mt-4 font-royal text-3xl font-extrabold text-white">Got the Purr.</h2>
        <p className="font-royal italic text-amber-300">You survived the ambush.</p>

        <div className="mt-6 grid grid-cols-3 gap-3">
          {[
            { label: "Affection", value: `${affection}%` },
            { label: "Ambushes", value: ambushes },
            { label: "Time", value: `${duration}s` },
          ].map((s) => (
            <div key={s.label} className="rounded-2xl bg-slate-900/60 border border-white/5 p-3">
              <p className="font-display text-xl font-bold text-sky-300">{s.value}</p>
              <p className="font-mono-ui text-[9px] uppercase tracking-widest text-slate-500">{s.label}</p>
            </div>
          ))}
        </div>

        <button
          onClick={onReplay}
          data-testid="victory-replay-button"
          style={{ transition: "transform 0.15s ease, background-color 0.2s ease" }}
          className="mt-6 flex w-full items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-amber-400 to-amber-500 py-3 font-display text-lg font-bold text-slate-900 hover:scale-[1.02] active:scale-95"
        >
          <RotateCcw className="h-5 w-5" /> Play Again
        </button>
      </motion.div>
    </div>
  );
}
